export type ArrayPoint = [string | number, ...(number | null)[]];

export interface Point {
  x: string | number;
  y?: number;
  low?: number;
  high?: number;
  [k: string]: any;
}

export interface ArraySeriesType {
  name?: string;
  data?: ArrayPoint[];
}

export interface PointSeriesType {
  name: string;
  data?: Point[];
}

export type SeriesType = ArraySeriesType | PointSeriesType;

export const ChartType = {
  LINE: 'line',
  AREA: 'area',
  BAR: 'bar',
  COLUMN: 'column',
  SPLINE: 'spline',
  AREA_SPLINE: 'areaspline',
  SCATTER: 'scatter',
  AREA_RANGE: 'arearange',
  AREA_SPLINE_RANGE: 'areasplinerange',
} as const;
export type ChartTypeOption = (typeof ChartType)[keyof typeof ChartType];

export const LegendPlacement = {
  BOTTOM: 'bottom',
  RIGHT: 'right',
} as const;
export type LegendPlacementOption = (typeof LegendPlacement)[keyof typeof LegendPlacement];

export const TimeSeriesChartType = {
  LINE: 'line',
  AREA: 'area',
  DOT: 'dot',
  BAR: 'bar',
} as const;
export type TimeSeriesChartTypeOption = (typeof TimeSeriesChartType)[keyof typeof TimeSeriesChartType];

export const LegendType = {
  HIDDEN: 'hidden',
  BOTTOM: 'bottom',
  RIGHT: 'right',
} as const;
export type LegendTypeOption = (typeof LegendType)[keyof typeof LegendType];

export const TooltipType = {
  HIDDEN: 'hidden',
  SINGLE: 'single',
  ALL: 'all',
} as const;
export type TooltipTypeOption = (typeof TooltipType)[keyof typeof TooltipType];

export const StackingType = {
  NONE: 'none',
  NORMAL: 'normal',
  PERCENT: 'percent',
} as const;
export type StackingTypeOption = (typeof StackingType)[keyof typeof StackingType];

export const BarOrientation = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
} as const;
export type BarOrientationOption = (typeof BarOrientation)[keyof typeof BarOrientation];

export const YAxisType = {
  LINEAR: 'linear',
  LOGARITHMIC: 'logarithmic',
} as const;
export type YAxisTypeOption = (typeof YAxisType)[keyof typeof YAxisType];
